export default "/images/vendor/flag-icon-css/flags/4x3/sh.svg?c5ab8c6e3ffc963e14fb32d4ac271ccd";